import { jsx as _jsx, jsxs as _jsxs } from "nativewind/jsx-runtime";
import React from 'react';
import { color } from '@/constant/color';
import * as S from './OptionsV2.style';
export default function OptionsV2({ options, value, columns = 2, onSelect, }) {
    const getWidth = () => {
        if (columns === 1)
            return '100%';
        if (columns === 3)
            return '30%';
        return '40%';
    };
    return (_jsx(S.Options, { children: options.map((option, i) => {
            var _a, _b;
            return (_jsx(S.PressableOption, { elementName: "option_single_select", disableLogging: true, style: { width: getWidth() }, selected: option.value === value, disabled: (_a = option.disabled) !== null && _a !== void 0 ? _a : false, onPress: () => onSelect(option.value), children: _jsx(S.OptionText, { selected: option.value === value, disabled: (_b = option.disabled) !== null && _b !== void 0 ? _b : false, children: option.label }) }, i));
        }) }));
}
OptionsV2.Multiple = function MultipleOptions({ options, values, columns = 2, onSelect, }) {
    function handleSelect(value) {
        if (values === null || values === void 0 ? void 0 : values.includes(value)) {
            onSelect(values.filter(v => v !== value));
        }
        else {
            if (!values) {
                onSelect([value]);
            }
            else {
                onSelect([...values, value]);
            }
        }
    }
    const getWidth = () => {
        if (columns === 1)
            return '100%';
        if (columns === 3)
            return '30%';
        return '40%';
    };
    return (_jsx(S.Options, { children: options.map((option, i) => {
            var _a;
            const selected = values === null || values === void 0 ? void 0 : values.includes(option.value);
            const isDisabled = ((_a = option.disabled) !== null && _a !== void 0 ? _a : false) && !selected;
            const Icon = option.icon;
            return (_jsx(S.PressableOption, { elementName: "option_multi_select", disableLogging: true, style: { width: getWidth() }, selected: selected, disabled: isDisabled, onPress: () => handleSelect(option.value), children: Icon ? (_jsxs(S.IconTextRow, { children: [_jsx(Icon, { color: isDisabled
                                ? color.gray40
                                : selected
                                    ? color.brandColor
                                    : color.black, pointColor: isDisabled
                                ? color.gray25
                                : selected
                                    ? color.brand15
                                    : color.brand25, width: 28, height: 28 }), _jsx(S.OptionText, { selected: selected, disabled: isDisabled, children: option.label })] })) : (_jsx(S.OptionText, { selected: selected, disabled: isDisabled, children: option.label })) }, i));
        }) }));
};
